import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';

export const OrgDashboardPostAListingPageContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "OrgDashboardPostAListingPageContainer" */
      './OrgDashboardPostAListingPageContainer.dynamic'
    ),
});
